import { Box, Skeleton } from '@factorialco/deprecated-design-system'

export const PrejoinSkeleton = () => {
  return (
    <Box
      style={{ width: '100%' }}
      height="full"
      position="relative"
      padding="s16"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        flexDirection="row"
        style={{ width: '100%' }}
        alignItems="center"
        justifyContent="center"
        height="full"
        gap="s64"
      >
        <Box
          style={{
            maxWidth: '1024px',
            width: 'calc(100% - 300px)',
            height: '100%',
            maxHeight: '600px',
          }}
          flexDirection="column"
          gap="s12"
          position="relative"
        >
          <Skeleton isLoading height="full" />

          <Box style={{ width: '100%' }} gap="s12" alignItems="center">
            <Box style={{ width: '100px' }} flexDirection="row" gap="s12">
              <Skeleton isLoading height="s40" />
              <Skeleton isLoading height="s40" />
            </Box>
            <Box style={{ width: '100%' }} flexDirection="row" gap="s12">
              <Skeleton isLoading height="s32" />
              <Skeleton isLoading height="s32" />
              <Skeleton isLoading height="s32" />
              <Skeleton isLoading height="s32" />
            </Box>
          </Box>
        </Box>

        <Box style={{ width: '300px' }} position="relative" gap="s8">
          <Box style={{ width: '100%' }} gap="s8" height="s64">
            <Skeleton isLoading height="full" />
            <Skeleton isLoading height="full" />
          </Box>
          <Box style={{ width: '75%' }} gap="s8" height="s24">
            <Skeleton isLoading height="full" />
          </Box>
          <Box style={{ width: '50%' }} gap="s8" height="s24">
            <Skeleton isLoading height="full" />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
